
import { logger } from '@sheerid/jslib';

let googleOauthFirstName: string;
let googleOauthLastName: string;
let googleOauthEmail: string;
let googleOauthId: string;

export const setGoogleOauthFirstName = (firstName: string) => {
    logger.info('Google Oauth first name set to:', firstName);
    googleOauthFirstName = firstName;
};

export const setGoogleOauthLastName = (lastName: string) => {
    logger.info('Google Oauth last name set to:', lastName);
    googleOauthLastName = lastName;
};

export const setGoogleOauthEmail = (email: string) => {
    logger.info('Google Oauth email set to:', email);
    googleOauthEmail = email;
};

export const setGoogleOauthId = (id: string) => {
    logger.info('Google Oauth ID set to:', id);
    googleOauthId = id;
};

export const getGoogleOauthFirstName = () => {
    return googleOauthFirstName;
};

export const getGoogleOauthLastName = () => {
    return googleOauthLastName;
};

export const getGoogleOauthEmail = () => {
    return googleOauthEmail;
};

export const getGoogleOauthId = () => {
    return googleOauthId;
};

export const resetGoogleOauthFirstName = () => {
    logger.info('Google Oauth first name reset');
    googleOauthFirstName = undefined;
};

export const resetGoogleOauthLastName = () => {
    logger.info('Google Oauth last name reset');
    googleOauthLastName = undefined;
};

export const resetGoogleOauthEmail = () => {
    logger.info('Google Oauth email reset');
    googleOauthEmail = undefined;
};

export const resetGoogleOauthId = () => {
    logger.info('Google Oauth ID reset');
    googleOauthId = undefined;
};
